import * as React from 'react';
import { useTheme } from '@kis-technologies/kis-ui';
import { Svg, CircleWhole, CircleValue, SvgText } from '../styled';
import { ProgressProps } from '../types';
import { CIRCUMFERENCE } from '../constants';

/**
 * Circular Progress that animates to display time remaining
 */

export const Progress = (props: ProgressProps) => {
  const muiTheme = useTheme();
  const strokeColor = muiTheme.palette.primary.main;
  const { size, time, startTime } = props;
  const onProgress = () => {
    const progressValue = (time - 1) / startTime;
    const dashoffset = CIRCUMFERENCE * (1 - progressValue);

    return dashoffset;
  };

  const timeInmin = Math.trunc(time / 60);
  const timeInsec = time % 60;

  return (
    <Svg size={size}>
      <SvgText>
        {timeInmin < 10 ? `0${timeInmin}` : `${timeInmin}`}:{timeInsec < 10 ? `0${timeInsec}` : `${timeInsec}`}
      </SvgText>
      <CircleWhole />
      <CircleValue dashoffset={onProgress()} strokeColor={strokeColor} />
    </Svg>
  );
};

Progress.defaultProps = {
  size: 310
};
